import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { IconManualLogCaretDown } from '@saucelabs/sl-component-icons';
import Collapse from 'react-css-collapse';

import Styles from './RealDevicesFiltersPanel.styles';

const context = classNames.bind(Styles);

class RealDevicesFiltersPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: props.defaultExpanded,
    };
  }

  handleClick = () => {
    const { isOpen } = this.state;

    this.setState({
      isOpen: !isOpen,
    });
  }

  render() {
    const { isOpen } = this.state;
    const { children, header } = this.props;

    return (
      <div className={Styles.default}>
        <div
          className={Styles.header}
          onClick={this.handleClick}
          role="presentation"
        >
          {header}
          <span className={context('icon', { rotate: isOpen })}>
            <IconManualLogCaretDown
              height={12}
              width={12}
            />
          </span>
        </div>
        <Collapse
          isOpen={isOpen}
          transition="height 250ms cubic-bezier(.4, 0, .2, 1)"
        >
          {children}
        </Collapse>
      </div>
    );
  }
}

RealDevicesFiltersPanel.propTypes = {
  children: PropTypes.node.isRequired,
  defaultExpanded: PropTypes.bool,
  header: PropTypes.string.isRequired,
};

RealDevicesFiltersPanel.defaultProps = {
  defaultExpanded: false,
};

export default RealDevicesFiltersPanel;
